// extracted by mini-css-extract-plugin
export var author = "tutorials-module--author--c2KaX";
export var authorName = "tutorials-module--authorName--96j7O";
export var brief = "tutorials-module--brief--mi7L6";
export var card = "tutorials-module--card--xlcag";
export var cover = "tutorials-module--cover--N4hF9";
export var image = "tutorials-module--image--dRV2G";
export var level = "tutorials-module--level--V09UG";
export var list = "tutorials-module--list--0UoRH";
export var text = "tutorials-module--text--8DmsP";